var _path, _path2, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64236 15.4004C4.87395 15.6805 5.10128 15.9502 5.32184 16.2055L1.28734 17.857L8.78884 20.924C9.06346 21.0363 9.37635 21.0363 9.65096 20.924L17.1514 17.857L13.1647 16.2257C13.3854 15.9705 13.6133 15.7008 13.8453 15.4206L17.5819 16.949C18.4324 17.2968 18.4323 18.4162 17.5819 18.764L10.0815 21.832L9.87275 21.9056C9.37756 22.053 8.83781 22.0285 8.35723 21.832L0.857908 18.764C0.0605674 18.4379 0.0101594 17.4335 0.707878 17.0227L0.857908 16.949L4.64236 15.4004Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8896 6.78857C15.8896 10.5378 9.13965 17.6 9.13965 17.6C9.13965 17.6 2.38965 10.5378 2.38965 6.78857C2.38965 3.03935 5.41173 0 9.13965 0C12.8676 0 15.8896 3.03935 15.8896 6.78857Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.13965,
    cy: 6.60078,
    rx: 3.375,
    ry: 3.3,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.01e16198b5ad35021ed13db7d94e4532.svg";
export { ForwardRef as ReactComponent };